// extracted by mini-css-extract-plugin
export default {"left":"FooterText_left__hN0SU","sub1":"FooterText_sub1__gMR9s","sub2":"FooterText_sub2__nbl2X"};